import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link as RouterLink } from 'react-router-dom';
import { pagePaths } from 'routes/paths';

/**
 * Library placeholder for /in-action. Surfaces the future destination
 * (public sets from community parsings) while the backend feature is in
 * flight — links over to the Community section's matching landing.
 */
const IALibraryComingSoon: React.FC = () => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    alignItems={{ xs: 'flex-start', sm: 'center' }}
    spacing={2}
    sx={{
      bgcolor: 'background.paper',
      border: '1px dashed',
      borderColor: 'primary.tableBorder',
      borderRadius: 2,
      px: { xs: 2, md: '24px' },
      py: { xs: 2, md: '20px' },
    }}
  >
    <Box
      sx={{
        alignItems: 'center',
        bgcolor: (theme) =>
          theme.palette.mode === 'light'
            ? 'rgba(59, 44, 147, 0.08)'
            : 'rgba(155, 124, 255, 0.15)',
        borderRadius: 1.5,
        color: 'primary.main',
        display: 'inline-flex',
        flex: 'none',
        height: 48,
        justifyContent: 'center',
        width: 48,
      }}
    >
      <GroupsIcon sx={{ fontSize: 26 }} />
    </Box>

    <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
      <Stack
        direction={'row'}
        alignItems={'center'}
        spacing={1}
        sx={{ flexWrap: 'wrap', rowGap: 0.5 }}
      >
        <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
          {'Готові публічні набори'}
        </Typography>
        <Box
          sx={{
            bgcolor: (theme) =>
              theme.palette.mode === 'light'
                ? 'rgba(59, 44, 147, 0.10)'
                : 'rgba(155, 124, 255, 0.18)',
            borderRadius: 999,
            color: 'primary.main',
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: '0.06em',
            px: 1.25,
            py: 0.375,
            textTransform: 'uppercase',
          }}
        >
          {'Скоро'}
        </Box>
      </Stack>
      <Typography sx={{ color: 'text.secondary', fontSize: 13.5, lineHeight: 1.5 }}>
        {
          'Тут з’являться готові набори з аналізів, які зробили інші користувачі. Можна буде підглядати тематичні підбірки й додавати їх до свого словника.'
        }
      </Typography>
    </Stack>

    <RouterLink
      to={'/' + pagePaths.communityInActionSets}
      style={{
        alignItems: 'center',
        color: 'inherit',
        display: 'inline-flex',
        flex: 'none',
        gap: 6,
        textDecoration: 'none',
      }}
    >
      <Typography
        sx={{ color: 'primary.main', fontSize: 13.5, fontWeight: 700 }}
      >
        {'Перейти в Спільноту'}
      </Typography>
      <ArrowForwardIcon sx={{ color: 'primary.main', fontSize: 18 }} />
    </RouterLink>
  </Stack>
);

export default IALibraryComingSoon;
